import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "../../../../environments/environment";
import { Injectable, SecurityContext } from "@angular/core";
import { StateAffiliationProcess } from "../../models/affiliation/state-affiliation-process";
import { HttpHeadersPortal, HttpService } from "../../http/http.service";

@Injectable({
  providedIn: "root",
})
export class EmailService {
  
  constructor(private httpService: HttpService, private _sanitizer: DomSanitizer) { }

  endOfTheProcess(
    isProcessSuccessFull: any,
    correo: string,
    request: any,
    affiliationType: string[]
  ) {
    return {
      codeRequest: isProcessSuccessFull ? request.settled : request.code,
      sentToEmail: correo,
      messageButtom: isProcessSuccessFull
        ? "Ir a inicio empreas"
        : "Volver a intentar",
      titleHeader: "Afiliaciones empresa",
      subtitleHeader: affiliationType[request.type - 1],
      title: isProcessSuccessFull
        ? "Tu proceso de afiliación  a finalizado con éxito"
        : "Tu proceso de afiliación no a finalizado con éxito",
      type: isProcessSuccessFull ? "successfull" : "error",
      messageDescription: isProcessSuccessFull
        ? `Hemos recibido la solicitud de afiliación satisfactoriamente. En los siguientes 3 días
          hábiles recibirás confirmación del estado de la afiliación.`
        : `Para procesar la solicitud, debes adjuntar todos los documentos. Hemos enviado al correo electrónico del
          contacto, el número de registro para que puedas retomar el proceso y adjuntar los documentos pendientes.
          Esperamos recibirlos muy pronto para tramitar la solicitud`,
      icon: isProcessSuccessFull ? "check" : "error_outline",
    } as StateAffiliationProcess;
  }

  initMail(code: string, email: string, position: number) {
    return {
      host: "smtp.office365.com",
      port: 587,
      to: email,
      subject: this.mailTitle[position],
      text: this.initDataHTML(this.mailSubject[position]),
      fileText: code,
    };
  }

  get mailTitle() {
    return ["Certificado solicitado"];
  }

  get mailSubject() {
    return ["Certificado solicitado"];
  }

  initDataHTML(title: string) {
    title = this._sanitizer.sanitize(SecurityContext.HTML, title);
    return `<table border-spacing="0" cellpadding="0" cellspacing="0" style="margin:auto; width:100%; max-width: 600px;">
    <thead style="background-color:#0067B1;">
        <tr>
            <td height="20" style="padding:20px;">
                <img src="https://colsstoragedigitalpru.blob.core.windows.net/preafiliaciones/resources/Logotipo.png"
                    alt="Logo Colsubsidio">
            </td>
        </tr>
        <tr>
            <td style="height:5px; width:100%; background-color:#FFD000;"></td>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td height="110" vertical-align="middle">
                <h1
                    style="font-family: 'Roboto', Arial, Helvetica,sans-serif; font-weight: 600; font-size:25px; color:#001F5B; text-align:center;">
                    Certificado de afiliación trabajador
                </h1>
            </td>
        </tr>
        <tr align="center">
            <td>
                <table border-spacing="0" cellpadding="0" cellspacing="0"
                    style="width: 494px;padding-bottom: 10px;border-radius: 15px;">
                    <tr>
                        <td style="width:50px;"> </td>
                    </tr>
                    <tr align="center">
                        <td style="background-color:#001f5b">
                            <img src="https://colsstoragedigitalpru.blob.core.windows.net/preafiliaciones/resources/banner-main.png"
                                alt="Check" style="display:block;background: #001f5b;padding: 0;margin: 0;">
                            <div style="background-color:#001f5b;margin-top: -18px;height: 95px;">
                                <p
                                    style="color: #ffffff;font-size: 16px;font-family: 'Roboto', Arial, Helvetica,sans-serif;margin: 0;">
                                    Apreciado cliente,
                                </p>
                                <p
                                    style="color: #ffffff;font-size: 16px;padding: 0 15px;font-family: 'Roboto', Arial, Helvetica,sans-serif;">
                                    En el archivo adjunto estamos enviando el Certificado de Afiliación solicitado.
                                </p>
                            </div>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </tbody>
</table>`;
  }

  public postMail(query?: any): Promise<any> {
    const headers: HttpHeadersPortal = {
        AUTHORIZATION: "bm9yZXBseQ=="
    };

    return new Promise((resolve, reject) => {
      this.httpService.post(
        environment.NOTIFICACIONES_API.PREFIJO_URL,
        environment.NOTIFICACIONES_API.ENDPOINT_EMAIL,
        query,
        {},
        headers
      ).subscribe(
        (response) => {
          try {
            localStorage.setItem("alert", "si");
            resolve(response);
          } catch (error) {
            reject(response);
          }
        },
        (fail) => {
          try {
            fail = fail.json();
            localStorage.setItem("alert", "no");
          } catch (error) {}
          reject(fail);
        }
      );
    });
  }
}
